import cookie from "react-cookies";
import axios from 'axios';
import {AuthHeader} from "../helper/auth.token"
import { UPDATE_APP_CLICK_TIME, UPDATE_STATE, INIT_STATE, CLEAR_FOLLOWING_STATUS, CLEAR_PRESENTING_STATUS, UPDATE_APP_CLOSED_STATE, UPDATE_APP_POSITION, START_PRESENTING } from '../action/morpheus.state.action'
import { presentAppKey } from "../component/neoviewer/apps/app_keys";

export const getNewState = () => {
    return {
        z: 0, 
        r: -1,
        x: -1, 
        y: -1,
        showGrid: false,
        gridColor: "",
        gridSize: 500, 
        gridWidth: 3, 
        digitalZoomStatus: false,
        annoColor: "black",
        previewColor: false, 
        app_state: {}, 
        apps_initialised: false, 
}}

const InitialState = getNewState()

export const viewerUrlReducer = ( state = InitialState , action) => {
    let returnableState = {};
    let allAppStates = {};
    let currentAppState = {};
    let newAppState = {};
    switch(action.type){
        case INIT_STATE:
            returnableState = Object.assign({}, state, action.urlState);
            return returnableState;
        case CLEAR_FOLLOWING_STATUS:
                returnableState = Object.assign({}, state, action.urlState);
                delete returnableState.presentCode;
                var encodedUrl = urlEncoder(returnableState);
                window.history.replaceState(returnableState, 'viewer_url', encodedUrl);
                updateAppSettingsInDb(returnableState.app_state);
                return returnableState;
        case CLEAR_PRESENTING_STATUS:
            returnableState = Object.assign({}, state, action.urlState);
            delete returnableState.app_state[presentAppKey.id].code;
            updateAppSettingsInDb(returnableState.app_state);
            return returnableState;
        case START_PRESENTING:
            returnableState = Object.assign({}, action.urlState);
            var encodedUrl = urlEncoder(returnableState);
            window.history.replaceState(returnableState, 'viewer_url', encodedUrl);
            updateAppSettingsInDb(returnableState.app_state);
            return returnableState;
        case UPDATE_STATE:
            returnableState = Object.assign({}, action.urlState);
            var encodedUrl = urlEncoder(returnableState);
            window.history.replaceState(returnableState, 'viewer_url', encodedUrl);
            return returnableState;
        case UPDATE_APP_CLOSED_STATE:
            allAppStates = state.app_state;
            currentAppState = allAppStates[action.appName] || {};
            newAppState = Object.assign({}, allAppStates, {
                [action.appName]: Object.assign({}, currentAppState, {
                    closed: action.appClosedStatus}) });
            returnableState = Object.assign({}, state, {
                app_state : newAppState
            });
            updateAppSettingsInDb(newAppState);
            return returnableState;
        case UPDATE_APP_POSITION:
            allAppStates = state.app_state;
            currentAppState = allAppStates[action.appName] || {};
            newAppState = Object.assign({}, allAppStates, {
                [action.appName]: Object.assign({}, currentAppState, {
                    position: action.appPosition}) });
            returnableState = Object.assign({}, state, {
                app_state : newAppState
            });
            updateAppSettingsInDb(newAppState);
            return returnableState;
        case UPDATE_APP_CLICK_TIME:
            allAppStates = state.app_state;
            currentAppState = allAppStates[action.appName] || {};
            newAppState = Object.assign({}, allAppStates, {
                [action.appName]: Object.assign({}, currentAppState, {
                    clicked_at: new Date().getTime()}) });
            
            let appVsClickTime = [];

            for (let key in newAppState) {
                appVsClickTime.push({
                    key: key, 
                    val: newAppState[key].clicked_at == undefined ? 0 : newAppState[key].clicked_at
                })
            }

            appVsClickTime = appVsClickTime.sort(function (a, b) {
                return a.val - b.val;
            });

            appVsClickTime.map((item, index) => {
                newAppState[item.key].zIndex = 9 + 2 * index;
            })
            
            returnableState = Object.assign({}, state, {
                app_state : newAppState
            });
            updateAppSettingsInDb(newAppState);
            return returnableState;
        default :
            returnableState = state
            return returnableState;
    }
}


export const updateAppSettingsInDb = (app_state) => {
    let url = `/api/morpheussetting/` + cookie.load('morpheus_setting').id + `/`;
    axios.put(url, {
        app_state
    }, {headers: {Authorization : AuthHeader()}})
        .then(response => {
            if(response.status === 200 || response.status === 301 || response.status === 302) {
            }
            else if(response.status === 403 || response.status === 401 || response.status === 400){
                console.log("Position Update Save Failed", response);
            }
        })
        .catch(err =>{
            console.log("Position Update Save Failed, ", err);
        });
}

export const urlEncoder = (partsOfUrl) => {
    var encodedUrl = '?';
    if (partsOfUrl === undefined) {
        return encodedUrl;
    }
    if ('x' in partsOfUrl) {
        encodedUrl += '&x=' + partsOfUrl.x;
    }
    if ('y' in partsOfUrl) {
        encodedUrl += '&y=' + partsOfUrl.y;
    }
    if ('z' in partsOfUrl) {
        encodedUrl += '&z=' + partsOfUrl.z;
    }
    if ('r' in partsOfUrl) {
        encodedUrl += '&r=' + partsOfUrl.r;
    }
    if ('digitalZoomStatus' in partsOfUrl) {
        encodedUrl += partsOfUrl.digitalZoomStatus ? '&digitalZoomStatus=true' : '';
    }
    if ('presentCode' in partsOfUrl) {
        encodedUrl += partsOfUrl.presentCode ? '&presentCode=' + partsOfUrl.presentCode : '';
    }
    return encodedUrl;
}